<template>
    <div class="live-camera-area" :style="{ width: `calc(100% - ${onvifAreaSize.x})` }">
        <camera-loader :has-video-error="hasVideoError" :camera-msg="cameraMsg" :retry-text="retryText"
            :connect="connect" />

        <live-camera-view v-if="camera && !isHykeCam" ref="videoPlayer" :camera="camera" :mode="mode"
            :onvif-enable="onvifEnable" :onvif-active="onvifActive" :on-fullscreen-change="onFullscreenChange"
            :video-player-area-height-offset="videoPlayerAreaHeightOffset" :onvif-area-size="onvifAreaSize"
            :video-player-width-by-height="videoPlayerWidthByHeight" :player-options="playerOptions"
            :zoom-size="zoomSize" :zoom-list="zoomList" :target-zoom="targetZoom" :zoom-clicked="zoomClicked"
            :current-moment-value-of="currentMomentValueOf" :play-start-moment-value-of="playStartMomentValueOf"
            :fps="fps" :thumbnails="thumbnails" :on-play="onPlay" :on-change-volume="onChangeVolume" :set-f-p-s="setFPS"
            :on-change-seek="onChangeSeek" :set-fullscreen="setFullscreen" :on-player-readied="onPlayerReadied"
            :on-player-play="onPlayerPlay" :on-player-pause="onPlayerPause" :on-player-error="onPlayerError"
            :on-player-ended="onPlayerEnded" :on-video-click="onVideoClick" :is-web-r-t-c="isWebRTC"
            :webrtc-url="webrtcUrl" :is-history-playback="isHistoryPlayback"/>

        <hyke-camera-view v-else :hyke-cam-height-px="hykeCamHeightPx" :hyke-cam-loader-show="hykeCamLoaderShow"
            :hyke-cam-loader-width-px="hykeCamLoaderWidthPx" :hyke-cam-loader-height-px="hykeCamLoaderHeightPx"
            :hyke-cam-loader-top-px="hykeCamLoaderTopPx" :hyke-cam-loader-left-px="hykeCamLoaderLeftPx"
            :hyke-cam-screen="hykeCamScreen" />

    </div>
</template>

<script>
import LiveCameraView from "./LiveCameraView.vue";
import HykeCameraView from "./HykeCameraView.vue";
import { CAMERA_MOVIE_TYPE } from "@/config/const";
import CameraLoader from "./CameraLoader.vue";

export default {
    components: { LiveCameraView, CameraLoader, HykeCameraView },
    props: {
        camera: Object,
        cameraMsg: String,
        hasVideoError: Boolean,
        retryText: String,
        connect: Function,
        isHykeCam: Boolean,
        mode: String,
        onvifEnable: Boolean,
        onvifActive: Boolean,
        onFullscreenChange: Function,
        videoPlayerAreaHeightOffset: String,
        onvifAreaSize: Object,
        videoPlayerWidthByHeight: String,
        playerOptions: Object,
        zoomSize: String,
        zoomList: Array,
        targetZoom: Number,
        zoomClicked: Function,
        currentMomentValueOf: Number,
        playStartMomentValueOf: Number,
        fps: Number,
        thumbnails: Array,
        onPlay: Function,
        onChangeVolume: Function,
        setFPS: Function,
        onChangeSeek: Function,
        setFullscreen: Function,
        hykeCamHeightPx: String,
        hykeCamLoaderShow: Boolean,
        hykeCamLoaderWidthPx: String,
        hykeCamLoaderHeightPx: String,
        hykeCamLoaderTopPx: String,
        hykeCamLoaderLeftPx: String,
        hykeCamScreen: Function,
        onPlayerReadied: Function,
        onPlayerPlay: Function,
        onPlayerPause: Function,
        onPlayerError: Function,
        onPlayerEnded: Function,
        isWebRTC: Boolean,
        webrtcUrl: String,
        onVideoClick: Function,
        isHistoryPlayback: Boolean,
    },
    data() {
        return { CAMERA_MOVIE_TYPE };
    },
};
</script>
<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";

.hykecam-camera-area {
    background-color: black;
    position: relative;
}

.hykecam-center {
    width: 55%;
    margin: 0 auto;
}

.hykecam-video {
    width: 100%;
    z-index: 10;
}

.loader {
    font-size: 10px;
    margin: 50px auto;
    text-indent: -9999em;
    width: 100px;
    height: 100px;
    border-radius: 50%;
    background: #ffffff;
    background: -moz-linear-gradient(left, #ffffff 10%, rgba(255, 255, 255, 0) 42%);
    background: -webkit-linear-gradient(left, #ffffff 10%, rgba(255, 255, 255, 0) 42%);
    background: -o-linear-gradient(left, #ffffff 10%, rgba(255, 255, 255, 0) 42%);
    background: -ms-linear-gradient(left, #ffffff 10%, rgba(255, 255, 255, 0) 42%);
    background: linear-gradient(to right, #ffffff 10%, rgba(255, 255, 255, 0) 42%);
    position: absolute;
    top: 20%;
    left: 40%;
    -webkit-animation: load3 1.4s infinite linear;
    animation: load3 1.4s infinite linear;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
    z-index: 20;
}

.loader:before {
    width: 50%;
    height: 50%;
    background: #ffffff;
    border-radius: 100% 0 0 0;
    position: absolute;
    top: 0;
    left: 0;
    content: '';
}

.loader:after {
    background: #000000;
    width: 75%;
    height: 75%;
    border-radius: 50%;
    content: '';
    margin: auto;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
}

@-webkit-keyframes load3 {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }

    100% {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}

@keyframes load3 {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>